<script setup lang="ts">
import { useI18n, onMounted, onUnmounted } from '#imports';
import { useToast } from '../composables/useToast';

const { t } = useI18n();
const toast = useToast();

// 处理会话过期事件
const handleSessionExpired = () => {
  try {
    toast.error(t('user.sessionExpired'));
  } catch (error) {
    console.error('处理会话过期事件失败:', error);
  }
};

// 处理 API 错误事件
const handleApiError = (event: CustomEvent) => {
  try {
    const { message, status } = event.detail;
    
    if (message) {
      toast.error(message);
    } else if (status === 401) {
      toast.error(t('user.sessionExpired'));
    } else {
      toast.error(t('create.toast.unknownError'));
    }
  } catch (error) {
    console.error('处理API错误事件失败:', error);
  }
};


onMounted(() => {
  try {
    console.log('GlobalToastListener: 组件已挂载');
    
    // 添加事件监听器
    if (typeof window !== 'undefined') {
      window.addEventListener('session-expired', handleSessionExpired);
      window.addEventListener('api-error', handleApiError as EventListener);
    }
  } catch (error) {
    console.error('GlobalToastListener挂载失败:', error);
  }
});

onUnmounted(() => {
  try {
    console.log('GlobalToastListener: 组件开始卸载');
    
    // 移除事件监听器
    if (typeof window !== 'undefined') {
      window.removeEventListener('session-expired', handleSessionExpired);
      window.removeEventListener('api-error', handleApiError as EventListener);
    }
    
    console.log('GlobalToastListener: 组件卸载完成');
  } catch (error) {
    console.error('GlobalToastListener卸载失败:', error);
  }
});
</script>

<template>
  <div class="hidden"><!-- 这是一个无渲染组件，只用于监听事件 --></div>
</template> 